import React, * as r from 'react'
import CssBaseline from '@mui/material/CssBaseline'
import Container from '@mui/material/Container'
import { createTheme, ThemeProvider } from '@mui/material/styles'

import Footer from '../organisms/Footer'
import NoticeCompoment from '../organisms/NoticeCompoment'
import OneColumnsPosts from '../organisms/OneColumnsPosts'
import TwoColumnsPosts from '../organisms/TwoColumnsPosts'
import LoadingCompoment from '../organisms/LoadingCompoment'
import SearchQueryTabs from '../parts/SearchQueryTabs'
import SearchQueriesDummy from '../parts/SearchQueriesDummy'
import Pagenate from '../parts/Pagenate'
import PagenateInput from '../parts/PagenateInput'
import CircularProgress from '@mui/material/CircularProgress'


import { Stores } from '../../services/store'
import { Paper, Box } from '@mui/material';
import { useWindowDimensions } from '../../utill/windowDimensions'
import { ShowColumn } from '../../types/index'
import RankingCompoment from '../organisms/RankingCompoment'


const theme = createTheme(
  {
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: "#fef4f4"
          }
        }
      }
    }
  }

);

export default function Blog() {

  const stores = Stores.useContainer()
  const [showPosts] = r.useState(10)

  const { width } = useWindowDimensions()
  const [showColumn, setShowColumn] = r.useState(1 as ShowColumn)
  const scrollRef = React.createRef<HTMLDivElement>()

  r.useEffect(() => {
    // TODO: 自分でいい具合に計算する必要あるかも。
    const selectColumn = width <= 480 ? 1 : 2
    setShowColumn(selectColumn)
  }, [width])

  /**対象のrefまでスクロール */
  const scrollToBottomOfList = React.useCallback(() => {
    scrollRef!.current!.scrollIntoView({
      behavior: 'smooth',
      block: 'end',
    })
  }, [scrollRef])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <RankingCompoment />
      <Container maxWidth="lg">
        <main id="main">
          {stores.endTime ? (<p
            style={{
              color: "#dd0000",
              fontWeight: "bold",
              fontSize: "18px"
            }}
          >割引情報は「{stores.endTime}」の情報をもとに作成しています。ただ間違っている可能性もあるので、最後は販売サイトで確認をお願い致します。</p>
          ) : (
            <Box
              sx={{
                textAlign: "center"
              }
              }>
              <CircularProgress />
            </Box>
          )}
          <Paper
            sx={{
              position: 'relative',
              mb: 4,
            }}>
            <LoadingCompoment
              loadingFunction={stores.NoticeReload}
              watchEffectProperty={[]}
            >
              <NoticeCompoment
                title="新着記事以外のお知らせ"
                notices={stores.notices}
              />
            </LoadingCompoment>
          </Paper>
          <Paper
            sx={{ mb: 4 }}
            ref={scrollRef}
          >
            <LoadingCompoment
              loadingFunction={stores.TaxonomyReload}
              watchEffectProperty={[]}
            >
              {(stores.isDummy === "AllDummy" || stores.isDummy === "CategoryDummy")
                ? <SearchQueriesDummy taxonomies={stores.taxonomies} />
                : <SearchQueryTabs taxonomies={stores.taxonomies} />
              }
            </LoadingCompoment>
          </Paper>

          <LoadingCompoment
            loadingFunction={stores.ArticleReload}
            watchEffectProperty={[stores.keyword]}
          >
            {stores.posts.length > 0 ? (
              <Paper>
                <PagenateInput
                  onChagenPageEvent={(newPage) => stores.setCurrentPage(newPage)}
                />
                <Pagenate
                  currentPage={stores.currentPage}
                  totalPage={Math.ceil(stores.posts.length / showPosts)}
                  onChagenPageEvent={(newPage) => stores.setCurrentPage(newPage)}
                />
                {showColumn === 1 ? (
                  <OneColumnsPosts posts={stores.slice(
                    stores.posts,
                    stores.currentPage,
                    showPosts,
                  )}
                  />
                ) : (
                  <TwoColumnsPosts posts={stores.slice(
                    stores.posts,
                    stores.currentPage,
                    showPosts,
                  )}
                  />
                )
                }
                <Pagenate
                  currentPage={stores.currentPage}
                  totalPage={Math.ceil(stores.posts.length / showPosts)}
                  onChagenPageEvent={(newPage) => { stores.setCurrentPage(newPage); scrollToBottomOfList() }}
                />
              </Paper>
            ) : (
              <span>検索結果はありませんでした</span>
            )}
          </LoadingCompoment>
        </main>
      </Container>
      <Footer
        title="いしゅぷれ -異種姦インプレッション-"
        description=""
      />
    </ThemeProvider >
  );
}
